import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import styles from './styles.scss';

export default class Breadcrumb extends Component {
  render() {
    const items = this.props.items.map((i, index) => {
      if (i.active) {
        return <li key={index}>{i.value}</li>;
      }
      return <li key={index}><Link to={i.href}>{i.value}</Link></li>;
    });
    return (
      <ul className={styles.breadcrumb}>
        {items}
      </ul>
    );
  }
}
